import { useEffect, useState } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { getCurrentSession } from '../lib/cognito';
import { useAuthStore } from '../store/authStore';
import LoadingSpinner from './LoadingSpinner';

// Wraps the authenticated app. Redirects to /login if not signed in.
export default function RequireAuth() {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const setSession = useAuthStore((s) => s.setCognitoSession);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // On mount, rehydrate session from Cognito storage if needed
    if (user) {
      setChecked(true);
      return;
    }
    getCurrentSession().then((s) => {
      if (s) setSession(s);
      setChecked(true);
    });
  }, [user, setSession]);

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--color-bg)' }}>
        <LoadingSpinner label="Checking session…" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
